export const EXCHANGE_AUTHORIZATION_CODE = 'EXCHANGE_AUTHORIZATION_CODE'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const LOGOUT = 'logout'
